import React from 'react';
import graphql from 'graphql';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { PageWrapper, mediaQueries, Heading, Paragraph, spacing } from '../components/Styling';
import HTMLtoJSX from '../components/HTMLtoJSX';

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > * {
    flex: 0 0 100%;
    ${mediaQueries.medium`
      flex: 0 0 48%;
    `};
  }
`;

const Picture = styled(Img)`
  max-width: 100%;
  height: auto;
`;

const ImageWrapper = styled.div`
  margin-bottom: ${spacing[3]};
  ${mediaQueries.medium`
      order: 2 !important;
    `};
`;

const StyledPage = styled(PageWrapper)`
  flex: 1;
  p {
    margin-top: 0;
  }
`;

export default ({ data, transition }) => {
  const { markdownRemark: page } = data;
  const { allFile: pictures } = data;
  return (
    <StyledPage style={transition && transition.style}>
      <Heading>{page.frontmatter.title}</Heading>
      <Flex>
        <ImageWrapper>
          <Picture
            sizes={
              pictures.edges.filter(
                image =>
                  image.node.name ===
                  page.frontmatter.image.match(/(\/media\/)(.*)(\.jpg|.png|.gif|.jpeg|.tiff|.webp)/)[2]
              )[0].node.childImageSharp.sizes
            }
          />
        </ImageWrapper>
        <HTMLtoJSX content={page.html} />
      </Flex>
    </StyledPage>
  );
};

export const aboutPageQuery = graphql`
  query AboutPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        image
        path
        title
      }
    }
    allFile(filter: { internal: { mediaType: { regex: "/(image)/" } } }) {
      edges {
        node {
          name
          childImageSharp {
            sizes(maxWidth: 750) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/about-page.js